import { mapActions, mapGetters } from "vuex";
import { isDefined } from "@utils/var.check";

export default {
  computed: {
    ...mapGetters("app", ["getProcessingState"]),
    processingId() {
      //to be overwritten
      return "";
    },
    getProcessingTriggerElement() {
      return this.getProcessingState(this.processingId);
    },
    isProcessing() {
      return isDefined(this.getProcessingTriggerElement);
    },
  },
  methods: {
    ...mapActions("app", ["setProcessingState", "removeProcessingState"]),
    setProcessing(triggerElement) {
      this.setProcessingState({ id: this.processingId, triggerElement: triggerElement });
    },
    resetProcessing() {
      this.removeProcessingState(this.processingId);
    },
  },
};
